import PropTypes from 'prop-types';
import { useTranslate } from 'react-admin';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { formatDeviceConfigSourceLabel } from '@/helpers/device/deviceConfig.js';

const DeviceConfigCell = ({ value, isSignificant }) => {
    if (value == null || value === '') {
        return (
            <Typography variant='body2' className='gray'>
                —
            </Typography>
        );
    }

    return (
        <Typography variant='body2' fontWeight={isSignificant ? 700 : 400}>
            {value}
        </Typography>
    );
};

DeviceConfigCell.propTypes = {
    value: PropTypes.string,
    isSignificant: PropTypes.bool,
};

export const DeviceConfigTable = ({ parameters }) => {
    const translate = useTranslate();

    return (
        <TableContainer className='device-config-table-container'>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>{translate('resources.parameter.fields.parameter')}</TableCell>
                        <TableCell>{translate('resources.parameter.fields.value')}</TableCell>
                        <TableCell>{translate('common.source')}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {parameters.map(item => (
                        <TableRow key={item.id} className={item.isSignificant ? 'device-config-row--significant' : undefined}>
                            <TableCell>
                                <DeviceConfigCell value={item.parameter} isSignificant={item.isSignificant} />
                            </TableCell>
                            <TableCell>
                                <DeviceConfigCell value={item.value} isSignificant={item.isSignificant} />
                            </TableCell>
                            <TableCell>
                                <DeviceConfigCell
                                    value={formatDeviceConfigSourceLabel(item.source, item.sourceValue, translate)}
                                    isSignificant={item.isSignificant}
                                />
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

DeviceConfigTable.propTypes = {
    parameters: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
            parameter: PropTypes.string,
            value: PropTypes.string,
            source: PropTypes.string,
            sourceValue: PropTypes.string,
            isSignificant: PropTypes.bool,
        }),
    ).isRequired,
};
